import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';

import { PersonalAccessTokensSection } from '../../authentication/components/PersonalAccessTokensSection';
import { Messages } from '../../codegen/Localize';
import { IServerUserInfo } from '../../userManagement/users/models/IServerUserInfo';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { UserSettingsHelper } from '../UserSettingsHelper';
import { ConnectedDevices } from './connected-clients/ConnectedClientsSection';
import { SavedCredentialsForDataSourceSetting } from './SavedCredentialsForDataSourceSetting';

export interface SecuritySettingsProps {
  //meta data realted to business logic
  serverUser: IServerUserInfo;
  isViewerSelf: boolean;
  isServerUserSubplace: boolean;
}

export function SecuritySettings(props: SecuritySettingsProps) {
  return (
    <>
    <h3 className={UserSettingsStyle.titleText}>{Messages.userSettings_Security_Header()}</h3>
    <div >
        {props.isViewerSelf && !props.isServerUserSubplace && <div>
            <div className={UserSettingsStyle.tbody}>
              <SavedCredentialsForDataSourceSetting serverUser={props.serverUser} />
            </div>
          </div>}
        {props.isViewerSelf && !props.isServerUserSubplace && UserSettingsHelper.getSectionDividerLine()}
        <div>
          <div className={UserSettingsStyle.tbody}>
            <ConnectedDevices serverUser={props.serverUser} />
          </div>
        </div>
        {FeatureFlags.personalAccessTokensEnabled && UserSettingsHelper.getSectionDividerLine() }
        {FeatureFlags.personalAccessTokensEnabled && <div>
          <div className={UserSettingsStyle.tbody}>
            <PersonalAccessTokensSection canCreatePersonalAccessTokens={props.isViewerSelf} serverUser={props.serverUser}/>
          </div>
        </div>}
        {UserSettingsHelper.getSectionDividerLine()}
    </div>
    </>
  );
}
